import { useContext, useMemo } from 'react';
import ClassNamesContext from './ClassNamesContext';
import { joinClassNames } from './utils';

var useClassName = function useClassName(key) {
  for (var _len = arguments.length, ownClassNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    ownClassNames[_key - 1] = arguments[_key];
  }

  var className = useContext(ClassNamesContext)[key];
  return useMemo(function () {
    return joinClassNames.apply(void 0, [className].concat(ownClassNames)) // eslint-disable-next-line react-hooks/exhaustive-deps
    ;
  }, [className].concat(ownClassNames));
};

export default useClassName;